// extracted by mini-css-extract-plugin
export default {"verified_part":"buttons_verified_part__b1yrS","verified":"buttons_verified__26QPN","restart_part":"buttons_restart_part__EyeGH","restart":"buttons_restart__2FMuX"};